import React, { useState, useEffect } from "react";

const CustomerSearch = ({
  searchTerm,
  excludeTerm,
  datalistData,
  handleSearch,
  handleExcludeSearch,
  resetSearch,
  dateFilter,
  formatDateRange,
}) => {
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    setIsFiltered(
      searchTerm !== "" || excludeTerm !== "" || dateFilter !== null
    );
  }, [searchTerm, excludeTerm, dateFilter]);

  return (
    <div className="search-container">
      <input
        type="search"
        id="search"
        className="search-box"
        placeholder="Search all"
        list="datalist"
        value={searchTerm}
        onChange={handleSearch}
      />
      <datalist id="datalist">
        {datalistData.map((item, index) => (
          <option key={index} value={item} />
        ))}
      </datalist>
      <div className="exclude-search-container">
        <input
          type="search"
          name="exclude"
          id="search-exclude"
          className="search-box exclude"
          placeholder="Exclude"
          list="datalist-exclude"
          value={excludeTerm}
          onChange={handleExcludeSearch}
        />
        <datalist id="datalist-exclude">
          {datalistData.map((item, index) => (
            <option key={index} value={item} />
          ))}
        </datalist>
        <button
          className={`button reset ${isFiltered ? "active" : ""}`}
          onClick={resetSearch}
        >
          Reset
        </button>
      </div>
      <div hidden>{formatDateRange(dateFilter)}</div>
    </div>
  );
};

export default CustomerSearch;
